<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="salaries"
      class="elevation-1"
      :loading="loading"
      :search="search"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search salaries"
            single-line
            hide-details
            class="shrink mx-4"
            title="Tìm kiếm"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-dialog v-model="dialog" max-width="500px" v-if="roles.read_salary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                v-if="roles.create_salary"
                title="Tạo bản ghi mới"
                >Add salaries</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" v-if="informText != ''">
                      <v-alert type="error" style="text-align: left">
                        {{ informText }}
                      </v-alert>
                    </v-col>

                    <v-col cols="6">
                      <v-combobox
                        v-model="userSelected"
                        :items="listUser"
                        item-text="name"
                        :item-value="(obj) => obj.username"
                        label="Nhân viên"
                        dense
                        outlined
                        v-if="editedIndex == -1"
                      ></v-combobox>
                      <v-overflow-btn
                        v-model="editedItem.username"
                        :items="listUser"
                        :item-text="(obj) => obj.username"
                        :item-value="(obj) => obj.username"
                        label="Nhân viên"
                        disabled
                        outlined
                        dense
                        v-else
                      ></v-overflow-btn>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.luong"
                        dense
                        outlined
                        label="Lương"
                        type="number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.phu_cap"
                        dense
                        outlined
                        label="Phụ Cấp"
                        type="number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.bao_hiem"
                        dense
                        outlined
                        label="Bảo Hiểm"
                        type="number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        persistent
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.tu_ngay"
                            label="Từ Ngày"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            v-if="editedIndex == -1"
                          ></v-text-field>
                          <v-text-field
                            v-model="editedItem.tu_ngay"
                            label="Từ Ngày"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            disabled
                            v-else
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.tu_ngay"
                          scrollable
                          @change="
                            showStoreSellerReport = false;
                            validation();
                          "
                          v-if="menu3"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.ghi_chu"
                        dense
                        outlined
                        label="Ghi Chú"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="check">Check</v-btn> -->
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                  v-if="showBtn == true && roles.update_salary"
                  >Save</v-btn
                >
                <v-btn color="blue darken-1" text v-else disabled>Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            color="primary"
            class="mb-2"
            v-else
            disabled
            title="Tạo bản ghi mới"
            >Add salaries</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.luong="{ item }">
        {{
          item.luong.toLocaleString("vi-VN", {
            style: "currency",
            currency: "VND",
          })
        }}
      </template>
      <template v-slot:item.luong="{ item }">
        <template v-if="item.luong">
          {{
            item.luong.toLocaleString("vi-VN", {
              style: "currency",
              currency: "VND",
            })
          }}
        </template>
      </template>
      <template v-slot:item.bao_hiem="{ item }">
        <template v-if="item.bao_hiem">
          {{
            item.bao_hiem.toLocaleString("vi-VN", {
              style: "currency",
              currency: "VND",
            })
          }}
        </template>
      </template>
      <template v-slot:item.phu_cap="{ item }">
        <template v-if="item.phu_cap">
          {{
            item.phu_cap.toLocaleString("vi-VN", {
              style: "currency",
              currency: "VND",
            })
          }}
        </template>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          x-small
          @click="editItem(item)"
          v-if="roles.read_salary"
          title="Sửa bản ghi"
        >
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        <v-btn color="primary" disabled x-small v-else title="Sửa bản ghi">
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        &nbsp;
        <v-btn
          color="orange"
          x-small
          dark
          @click="deleteItem(item)"
          v-if="roles.delete_salary"
          title="Xoá bản ghi"
        >
          <v-icon small> mdi-delete </v-icon>
        </v-btn>
        <v-btn color="orange" x-small disabled v-else title="Xoá bản ghi">
          <v-icon small> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment-timezone";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "salaries",
  //new Vue({
  data: () => ({
    menu3: false,
    search: "",
    loading: true,
    dialog: false,
    dropdown: [],
    headers: [
      {
        text: "Nhân viên",
        align: "start",
        value: "name",
      },
      { text: "Lương", value: "luong" },
      { text: "Phụ Cấp", value: "phu_cap" },
      { text: "Bảo Hiểm", value: "bao_hiem" },
      { text: "Từ Ngày", value: "tu_ngay" },
      { text: "Ghi Chú", value: "ghi_chu" },
      { text: "Thao tác", value: "actions", sortable: false },
    ],
    salaries: [],
    listUser: [],
    userSelected: [],
    editedIndex: -1,
    editedItem: {
      _id: "",
      username: [],
      luong: 0,
      phu_cap: 0,
      bao_hiem: 0,
      tu_ngay: "",
      ghi_chu: "",
    },
    beforeEditItem: {
      _id: "",
      username: [],
      luong: 0,
      phu_cap: 0,
      bao_hiem: 0,
      tu_ngay: "",
      ghi_chu: "",
    },
    defaultItem: {
      _id: "",
      username: [],
      luong: 0,
      phu_cap: 0,
      bao_hiem: 0,
      tu_ngay: "",
      ghi_chu: "",
    },
    showBtn: null,
    informText: "",
    roles: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
      if (val == true && this.editedIndex == -1) {
        this.showBtn = null;
        this.validation();
      } else {
        this.showBtn = null;
        this.validation();
      }
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "salaries-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "salaries", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("salaries Response: ", response);
            this.salaries = response.data.data.salaries;
            this.listUser = response.data.data.members;
            for (const item of this.salaries) {
              item.tu_ngay = moment(item.tu_ngay)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MM/YYYY");
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession salaries-loadData-undefined: ",
          currentSession
        );
      }
      this.loading = false;
    },

    editItem(item) {
      this.editedIndex = this.salaries.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.beforeEditItem = Object.assign({}, this.editedItem);
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.salaries.indexOf(item);
      var r =
        confirm("Are you sure you want to delete this item?") &&
        this.salaries.splice(index, 1);
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "salaries-delete"
        );
        if (currentSession.accessToken) {
          axios
            .delete(window.domain + "salaries/" + item._id, {
              headers: { Authorization: currentSession.accessToken },
            })
            .then((response) => console.log("salaries-delete: ", response))
            .catch((error) => {
              console.log("Error:", error);
            });
        } else {
          console.log(
            "currentSession salaries-delete-undefined: ",
            currentSession
          );
        }
      }
    },

    close() {
      this.dialog = false;
      this.informText = "";
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.showBtn = false;
      this.editedItem.username = this.userSelected.username;
      var currentSession = await this.$root.$refs.App.currentSession(
        "salaries-saveData"
      );
      if (currentSession.accessToken) {
        if (this.editedIndex > -1) {
          //var a = Object.assign(this.salaries[this.editedIndex], this.editedItem)
          await fetch(window.domain + "salaries/" + this.editedItem._id, {
            method: "PUT",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(this.editedItem),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("edit salaries response: ", data);
              if (data.error_message == "") {
                this.close();
                this.informText = "";
                Object.assign(this.salaries[this.editedIndex], this.editedItem);
              } else {
                this.informText = data.error_message;
              }
            })
            .catch((error) => console.log(error));
        } else {
          console.log("editedItem: ", this.editedItem);
          await fetch(window.domain + "salaries", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(this.editedItem),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("add salaries response: ", data);
              if (data.error_message == "") {
                this.close();
                this.informText = "";
                var item = data.data;
                item.tu_ngay = moment(item.tu_ngay)
                  .tz("Asia/Ho_Chi_Minh")
                  .format("DD/MM/YYYY");
                this.salaries.push(item);
              } else {
                this.informText = data.error_message;
              }
            })
            .catch((error) => console.log(error));
        }
        //this.close()
      } else {
        console.log(
          "currentSession salaries-saveData-undefined: ",
          currentSession
        );
      }

      this.userSelected = [];
    },

    check() {
      console.log(this.editedItem);
    },

    validation() {
      if (
        this.editedItem.luong != "" &&
        this.editedItem.tu_ngay != "" &&
        this.editedItem.name != ""
      ) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("salary");
    if (this.roles.list_salaries) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>